export default __webpack_public_path__ + "static/speedy4-5087af543dbeeb23f9ed2285e5866bfb.svg";